// extracted by mini-css-extract-plugin
export default {"not-found":"not-found-XuVvC","not-found-text":"not-found-text-n1mJl"};